import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";




export class UserLiveApis extends AxiosGlobal {

    //Links Apis


    trackShipment(id: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/shipment/track-shipment`, id, {
            headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Access-Control-Allow-Origin": "*" },
        });
    }






}